import { Icons } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { refetchFunc } from 'modules/domain/common/hooks'
import { User } from 'modules/domain/user/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PermissionCheck from 'views/components/PermissionCheck/PermissionCheck'
import { Verified, VerifiedDate } from '../../styled'
import { CoordinatorConfirmModal } from './ConfirmModals/CoordinatorConfirmModal'

type Props = {
  userRefetch: refetchFunc
  user: User
}

export const VerifiedByCoordinator = ({ user, userRefetch }: Props) => {
  const { t } = useTranslation('user')
  const formatDate = useFormatDate()
  const [verifyCoordinatorModal, setVerifyCoordinatorModal] = useState(false)

  if (!user.profile) return null

  return (
    <>
      <PermissionCheck scope={['users.can_verify_as_coordinator']}>
        <div>
          <Verified
            isVerified={user.profile.is_verified_by_coordinator}
            onClick={() => setVerifyCoordinatorModal(true)}
          >
            <div>
              <Icons.IconCheckMark />
              <span>{t('verify_coordinator')}</span>
            </div>
          </Verified>
          {user.profile.verified_by_coordinator_at && (
            <VerifiedDate>{formatDate(user.profile.verified_by_coordinator_at)}</VerifiedDate>
          )}
        </div>
      </PermissionCheck>

      {verifyCoordinatorModal && (
        <CoordinatorConfirmModal
          onClose={() => setVerifyCoordinatorModal(false)}
          refetch={userRefetch}
          userId={user.id}
        />
      )}
    </>
  )
}
